import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { 
  Table, 
  Button, 
  Typography, 
  Alert, 
  Space, 
  Tag 
} from "antd";
import { EyeOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";

const { Title } = Typography;

const RoutesPage = () => {
  const navigate = useNavigate();
  const [routes] = useState([
    {
      id: 1,
      vehicle: "Truck 1",
      driver: "John Doe",
      status: "Planned",
      date: "2024-01-15",
    },
    {
      id: 2,
      vehicle: "Van 2",
      driver: "Jane Smith",
      status: "In Progress",
      date: "2024-01-10",
    },
    {
      id: 3,
      vehicle: "Truck 3",
      driver: "Alice Brown",
      status: "Completed",
      date: "2024-01-20",
    },
  ]);

  // Table columns configuration
  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: '10%',
    },
    {
      title: 'Vehicle',
      dataIndex: 'vehicle',
      key: 'vehicle',
      width: '20%',
    },
    {
      title: 'Driver',
      dataIndex: 'driver',
      key: 'driver',
      width: '20%',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: '15%',
      render: (status) => {
        let color = 'default';
        if (status === 'Completed') color = 'success';
        else if (status === 'Planned') color = 'warning';
        else if (status === 'In Progress') color = 'processing';
        return <Tag color={color}>{status}</Tag>;
      },
    },
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
      width: '15%',
    },
    {
      title: 'Actions',
      key: 'actions',
      width: '20%',
      render: (_, record) => (
        <Space>
          <Button
            type="link"
            icon={<EyeOutlined />}
            onClick={() => navigate(`/routes/${record.id}`)}
            title="View"
          >
            View
          </Button>
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => navigate(`/routes/${record.id}/edit`)}
            title="Edit"
          >
            Edit
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div>
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <Title level={1} style={{ margin: 0 }}>Routes</Title>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => navigate("/routes/plan")}
        >
          Plan New Route
        </Button>
      </div>

      {routes.length === 0 ? (
        <Alert
          message="No routes found"
          description="No routes available."
          type="info"
          showIcon
        />
      ) : (
        <Table
          columns={columns}
          dataSource={routes}
          rowKey="id"
          pagination={false}
          size="middle"
        />
      )}
    </div>
  );
};

export default RoutesPage;
